import { Company } from "../model/Companies";
import { Result } from "../model/Result";
import axiosCilent from "./axiosClient";


const companiesApi = {
  requestCompaniesAdd: async (company:Company): Promise<Result> =>  {
    try {
      // ログイン中のユーザー情報
      const response = await axiosCilent.post(`add`, company);
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },

  // 契約数増減数による利用者の追加および削除処理を行うAPIリクエスト
  requestUsersCountUpdate: async (
    afterUsersCount: number,
    tenantId: string
  ): Promise<Result> =>  {
    try {
      const response = await axiosCilent.post(`updateUsersCountUpdate`, {afterUsersCount, tenantId});
      return response.data;
    } catch (error: any) {
      console.log("error")
      console.log(error)
      return Promise.reject({'process': '', 'status': 'error'})
    }
  },

  // オプション管理の権限取得を行うAPIリクエスト
  requestGetOptionAuth: async (
    tenantId: string,
    targetNo: number,
  ): Promise<Result> =>  {
    try {
      const response = await axiosCilent.post(`getOptionAuth/${tenantId}/${targetNo}`);
      return response.data;
    } catch (error: any) {
      console.log(error)
      return {success: false, data: error};
    }
  },

  // 利用者IDカードの権限取得を行うAPIリクエスト
  requestIdCardAuth: async (
    tenantId: string,
  ): Promise<Result> =>  {
    try {
      const response = await axiosCilent.post(`getIdcardAuth/${tenantId}`, {});
      return response.data;
    } catch (error: any) {
      console.log(error)
      return {success: false, data: error};
    }
  },

  // 団体一覧取得
  requestGetCompanies: async (
    pageNo: number,
    pageSize: number,
    showDeleted = false,
    sortField?: string,
    sortOrder?: string
  ): Promise<{ success: boolean; companies?: Company[]; totalCount?: number }> => {
    try {
      const requestBody = { page: pageNo, limit: pageSize, showDeleted, sortField: sortField || 'displayId', sortOrder: sortOrder || 'ASC' };
      const response = await axiosCilent.post(`/getCompaniesListDb`, requestBody, { timeout: 0 });
      return { success: true, companies: response.data.companies, totalCount: response.data.totalCount };
    } catch (error) {
      console.error(error);
      return { success: false };
    }
  },
};

export default companiesApi;
